<template>
  <div>
    <!-- 点标注图标 -->
    <template v-for="(marker, index) in pointMarkers">
      <l-marker
        v-if="marker.position && marker.position.length === 2 && marker.visible !== false"
        :key="`point_marker_${marker.id || index}_${Date.now()}`"
        :lat-lng="marker.position"
        :icon="createUniqueIcon(marker, index)">
        <l-tooltip 
          v-if="marker.label"
          :options="createUniqueTooltipOptions(marker, index)">
          {{ marker.label }}
        </l-tooltip>
      </l-marker>
    </template>
  </div>
</template>

<script>
import { LMarker, LTooltip } from 'vue2-leaflet'
import L from 'leaflet'

export default {
  name: 'PointMarkers',
  components: {
    LMarker,
    LTooltip
  },
  props: {
    pointMarkers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      L: L // 暴露L对象给模板使用
    }
  },
  methods: {
    /**
     * 为每个标记创建独立的图标实例
     * @param {Object} marker - 标记数据
     * @param {Number} index - 标记索引
     * @returns {L.DivIcon} - Leaflet图标实例
     */
    createUniqueIcon(marker, index) {
      // 为每个图标生成稳定的唯一类名，避免DOM重用问题
      const uniqueClassName = `custom-point-marker-${marker.id || `idx-${index}`}`;
      
      // console.log('marker',marker)

      return L.divIcon({
        className: uniqueClassName,
        html: `<div class='marker-icon-container' style='color: ${marker.color || '#ff4444'};'>
                 <i class='${marker.icon ||marker.iconName || 'el-icon-location'}'></i>
               </div>`,
        iconSize: [24, 24],
        iconAnchor: [12, 12]
      });
    },

    /**
     * 为每个tooltip创建独立的配置选项
     * @param {Object} marker - 标记数据
     * @param {Number} index - 标记索引
     * @returns {Object} - Tooltip配置选项
     */
    createUniqueTooltipOptions(marker, index) {
      // 为每个tooltip生成稳定的唯一类名，避免样式冲突
      const uniqueTooltipClassName = `point-marker-label-${marker.id || `idx-${index}`}`;
      
      return {
        permanent: true,
        offset: [24, 0],
        className: uniqueTooltipClassName,
        direction: 'right',
        interactive: false
      };
    }
  }
}
</script>

<style>
/* 自定义点标注图标样式 - 使用属性选择器匹配所有动态类名 */
[class*="custom-point-marker"] {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.marker-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 18px;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.5);
  /* 确保图标居中 */
  position: relative;
  left: 0;
  top: 0;
}

/* 点标注标签样式 - 使用属性选择器匹配所有动态类名 */
[class*="point-marker-label"] {
  background-color: rgba(0, 0, 0, 0.7) !important;
  border: none !important;
  box-shadow: none !important;
  color: white !important;
  font-weight: bold !important;
  padding: 4px 8px !important;
  border-radius: 4px !important;
  font-size: 12px !important;
  white-space: nowrap !important;
  text-align: center !important;
  /* 确保tooltip显示在合适位置 */
  pointer-events: none !important;
  z-index: 1000 !important;
}
</style> 